import { render, staticRenderFns } from "./Rules.vue?vue&type=template&id=241d1cf9&scoped=true"
import script from "./Rules.js?vue&type=script&lang=js&external"
export * from "./Rules.js?vue&type=script&lang=js&external"
import style0 from "./Rules.scss?vue&type=style&index=0&id=241d1cf9&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241d1cf9",
  null
  
)

export default component.exports